// Redux Actions
import { POST } from 'utils/fetchWrappers';
import {
    API_DOWNLOAD_BULK_ACCOUNT_VERIFICATION_PRE_FILLED_FILE,
    API_FETCH_STATUS_BULK_ACCOUNT_VERIFICATION,
    API_UPLOAD_BULK_ACCOUNT_VERIFICATION_FILE,
    API_DOWNLOAD_BULK_ACCOUNT_VERIFICATION_FILE,
} from 'utils/API/apiUrls';
import { apiStatusCodes } from 'utils/API/apiStatusCodes';
import * as loaderActions from '../../../redux/common/loader/loader.actions';
import {
    downloadBulkAccountVerificationPreFilledFileCSV,
    downloadFile,
} from '../../../utils/helperMethods';
import * as bulkAccountVerificationActions from './BulkAccountVerification.actions';

// constants
import {
    DOWNLOAD_PRE_FILLED_BULK_ACCOUNT_VERIFICATION_FILE_REQUEST,
    DOWNLOAD_BULK_ACCOUNT_VERIFICATION_REQUEST,
    GET_STATUS_BULK_ACCOUNT_VERIFICATION_REQUEST,
    UPLOAD_BULK_ACCOUNT_VERIFICATION_REQUEST
} from './BulkAccountVerification.constants';

// Library
import { toast } from 'react-toastify';
import { takeLatest, put, call } from 'redux-saga/effects';

const getCsvData = async () => {
    let fileName = 'downloaded_file';
    let csvData = '';
    try {
        let response = await POST(
            API_DOWNLOAD_BULK_ACCOUNT_VERIFICATION_PRE_FILLED_FILE,
            {}
        );
        csvData = response.data;
        // Extract fileName from the 'Content-Disposition' header
        const contentDisposition = response.headers['content-disposition'];
        if (contentDisposition) {
            const filenameMatch = contentDisposition.split('filename=');
            // console.log('fileName match', filenameMatch);
            if (filenameMatch && filenameMatch[1]) {
                fileName = filenameMatch[1];
            }
        }
        return { csvData, fileName };
    } catch (e) {
        // console.log('get csv data error', e.message);
        return { csvData, fileName };
    }
};

export function* downloadBulkAccountVerificationPreFilledFile() {
    yield put(loaderActions.showLoader());
    try {
        let response = yield call(getCsvData);

        let { csvData, fileName } = response;
        if (!csvData) {
            throw new Error("No data available!")
        }
        const downloadResponse = yield call(downloadBulkAccountVerificationPreFilledFileCSV, csvData, fileName);
        if (!downloadResponse.status) {
            throw new Error(downloadResponse.message);
        }

        //success response action called
        yield put(
            bulkAccountVerificationActions.downloadBulkAccountVerificationFileSuccess()
        );
    } catch (error) {
        // const { data } = response;
        const errorMessage = error.message
            ? error.message
            : 'Something went wrong. Please try again after sometime.';
        // console.log('error', error);
        toast.error(errorMessage);
    }
    yield put(loaderActions.hideLoader());
}

export function* fetchStatusBulkAccountVerification(actions) {
    yield put(loaderActions.showLoader());
    try {
        const { payload } = actions;
        // console.log("actions payload", payload);
        const requestPayload = {
            fileProcessEnum: 'BULK_ACCOUNT_VERIFICATION_FILE_UPLOAD',
            ...payload,
        };

        const { data } = yield call(
            POST,
            API_FETCH_STATUS_BULK_ACCOUNT_VERIFICATION,
            requestPayload
        );

        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(
                bulkAccountVerificationActions.fetchStatusBulkAccountVerificationSuccess(data)
            );
        } else if (data && data.errorMessage) {
            yield put(
                bulkAccountVerificationActions.fetchStatusBulkAccountVerificationFailed({
                    error: data.errorMessage,
                })
            );
            toast.info(data.errorMessage);
        }
    } catch ({ response }) {
        const { data } = response;

        const errorMessage = data.errorMessage
            ? data.errorMessage
            : 'Something went wrong. Please try again after sometime.';

        bulkAccountVerificationActions.fetchStatusBulkAccountVerificationFailed({
            error: errorMessage,
        });

        toast.error(errorMessage);
    }
    yield put(loaderActions.hideLoader());
}

export function* uploadBulkAccountVerificationFile(actions) {
    yield put(loaderActions.showLoader());
    try {
        const { payload } = actions;

        const pageSize = payload.get('pageSize');
        if (pageSize) payload.delete('pageSize');

        const { data } = yield call(
            POST,
            API_UPLOAD_BULK_ACCOUNT_VERIFICATION_FILE,
            payload,
            {
                'Content-Type': 'multipart/form-data;',
            },
            true
        );

        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            toast.info('File Uploaded Successfully');
            yield put(
                bulkAccountVerificationActions.fetchStatusBulkAccountVerificationRequest({ pageSize, pageNo: 1 })
            );
        } else if (data && data.errorMessage) {
            toast.info(data.errorMessage);
        }
    } catch ({ response }) {
        const { data } = response;
        const errorMessage = data.errorMessage
            ? data.errorMessage
            : 'Something went wrong. Please try again after sometime.';
        toast.error(errorMessage);
    }
    yield put(loaderActions.hideLoader());
}

export function* downloadBulkAccountVerificationFile(actions) {
    yield put(loaderActions.showLoader());
    try {
        // console.log("...called file download");
        const { payload } = actions;
        // console.log("...", payload);
        const { data } = yield call(
            POST,
            API_DOWNLOAD_BULK_ACCOUNT_VERIFICATION_FILE,
            payload
        );
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            downloadFile(data.fileUrl);
        } else if (data && data.errorMessage) {
            toast.error(data.errorMessage);
        }
    } catch ({ response }) {
        const { data } = response;
        const errorMessage = data.errorMessage
            ? data.errorMessage
            : 'Something went wrong. Please try again after sometime.';
        toast.error(errorMessage);
    }
    yield put(loaderActions.hideLoader());
}

/**
 * WATCHER SAGA
 */
export function* bulkAccountVerificationSaga(actions) {
    yield takeLatest(
        DOWNLOAD_PRE_FILLED_BULK_ACCOUNT_VERIFICATION_FILE_REQUEST,
        downloadBulkAccountVerificationPreFilledFile
    );
    yield takeLatest(
        GET_STATUS_BULK_ACCOUNT_VERIFICATION_REQUEST,
        fetchStatusBulkAccountVerification
    );
    yield takeLatest(
        UPLOAD_BULK_ACCOUNT_VERIFICATION_REQUEST,
        uploadBulkAccountVerificationFile
    );
    yield takeLatest(
        DOWNLOAD_BULK_ACCOUNT_VERIFICATION_REQUEST,
        downloadBulkAccountVerificationFile
    );
}
